import { BASE_URL } from '../constants/api';
import { io } from 'socket.io-client';
import Store from '../stores/Store';
import { isFalsy, showAutoCloseAlert } from '../utils';
import { route } from 'preact-router';

// "undefined" means the URL will be computed from the `window.location` object
// const baseUrl = 'http://localhost:8668';
const baseUrl = BASE_URL;

// /customerApi
// /session

const socketInstance = namespaces => {
  return io(`${baseUrl.replace('/api/', '')}/${namespaces}`, {
    query: (() => {
      const store = new Store();
      const xToken = store.get('x-token') || '';
      const csrf = store.get('x-csrf') || '';
      const xRegToken = store.get('x-reg-token') || '';

      let ts = {};

      csrf && (ts['x-csrf'] = csrf);
      xToken && (ts['x-token'] = xToken);
      xRegToken && (ts['x-reg-token'] = xRegToken);

      return ts;
    })(),
    transports: ['websocket'],
  });
};

export const socket = socketInstance('customerApi');
export const socketSession = socketInstance('session');

const getSessionToken = () => {
  const store = new Store();
  const token = store.get('token') || '';
  const xToken = store.get('x-token') || '';
  const csrf = store.get('x-csrf') || '';
  const xRegToken = store.get('x-reg-token') || '';

  let ts = {};

  csrf && (ts['x-csrf'] = csrf);
  xToken && (ts['x-token'] = xToken);
  xRegToken && (ts['x-reg-token'] = xRegToken);
  token && (ts['token'] = token);
  return ts;
};

export const Emit = function (event, payload, callback) {
  if (
    !payload ||
    (payload?.constructor?.name && payload?.constructor?.name != 'Object')
  ) {
    return;
  }

  payload.headers = getSessionToken();
  // console.log(62, 'socket');
  // console.log(63, socket);
  // console.log(64, event, payload);

  socket.emit(event, payload, data => {
    // console.log(49, data);
    callback(data);
  });
};

export const RefreshSession = callback => {
  const store = new Store();
  const sessionToken = getSessionToken();
  let email = store.get('email');
  if (!sessionToken['x-token']) {
    return;
  }
  socketSession.emit(
    'refresh',
    {
      'x-token': sessionToken['x-token'],
      'x-csrf': sessionToken['x-csrf'],
      email,
      headers: sessionToken,
    },
    (response = {}) => {
      // console.log('refresh');
      if (response.status && response.token) {
        store.put('x-token', response.token);
      }
      callback(response);
    }
  );
};

export const AutoRefresh = (condition, callback) => {
  const t = setInterval(() => {
    // console.log(98, condition);
    if (condition) {
      RefreshSession(callback);
    } else {
      clearInterval(t);
    }
  }, 30000);

  return () => {
    clearInterval(t);
  };
};

export const VerifySession = () => {
  setTimeout(checkSession, 5000);
};

async function checkSession() {
  try {
    const store = new Store();
    const sessionToken = getSessionToken();

    const xRegToken = sessionToken['x-reg-token'];
    const xToken = sessionToken['x-token'];
    const xCsrf = sessionToken['x-csrf'];

    let viewonly = store.get('viewonly');
    let status = store.get('status');
    let last_login = store.get('last_login');
    let email = store.get('email');

    const hasXToken = !!xToken;
    const hasXRegToken = !!xRegToken;
    const hasLogin = viewonly != null && status != null && email != null;

    /**
     * it means the session is x-reg-token or registering;
     */
    if (!hasXToken && hasXRegToken && hasLogin) {
      return setTimeout(checkSession, 2000);
    }

    if (isFalsy(xCsrf, 10)) {
      return showAutoCloseAlert({
        html: 'You will be logged out in <b></b> milliseconds.',
        title: 'Success',
        icon: 'success',
        timer: 1500,
        timerProgressBar: true,
      }).then(() => {
        route('/logout', true);
      });
    }

    socketSession.emit(
      'session',
      {
        viewonly,
        status,
        last_login,
        email,
        headers: sessionToken,
        'x-token': sessionToken['x-token'],
        'x-csrf': sessionToken['x-csrf'],
      },
      (session = {}) => {
        // console.log('second test', session);
        if (session.status == 0) {
          return showAutoCloseAlert({
            html: 'You will be logged out in <b></b> milliseconds.',
            title: 'Success',
            icon: 'success',
            timer: 1500,
            timerProgressBar: true,
          }).then(() => {
            route('/logout', true);
            setTimeout(() => location.reload(), 2000);
          });
        }
        setTimeout(checkSession, 2000);
      }
    );
    // console.log(106,session);
  } catch (err) {
    console.log(1175, err);
    setTimeout(checkSession, 2000);
  }
}
